import { nameof } from '@work4all/data/lib/helper/nameof';

import { RaPayment } from '@work4all/models/lib/Classes/RaPayment.entity';
import { RaViewModel } from '@work4all/models/lib/Classes/RaViewModel.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/raPayment-table-schema.json';
import { EntityTableLayoutV8Props } from '../table/EntityTableLayoutV8';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

const RA_PAYMENT_FORCE_REQUEST_FIELDS: RaPayment<EMode.query> = {
  ledgerAccountId: null,
  sachkontoCode: null,
  userId: null,
};

export function RaPaymentsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<RaPayment, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    innerEntityQuery: {
      parentEntity: Entities.raViewModel,
      fieldName: nameof<RaViewModel>('payments'),
    },
    forceRequestFields: RA_PAYMENT_FORCE_REQUEST_FIELDS,
    enableMultiRowSelection: false,
  });

  const overrides: Partial<EntityTableLayoutV8Props> = {
    layout: 'table',
    areas: null,
    hideSearch: true,
    cardConfig: null,
    displayFooter: false,
    actions: {
      groupingEnabled: null,
    },
  };

  return <EntityTableV8 {...props} {...dataTable} overrides={overrides} />;
}
